// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"M7-z"};